import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { CategoryStoreGroupPayload, CategoryStoreGroupResponse } from "@/types/interface/category-store-group";
import { ref } from "vue";
import { db } from "@/database/db";

const loginInfo = ref();
const stringLoginInfo = await db.storage.get('login-info');
loginInfo.value = stringLoginInfo?.data;

async function createCategoryGroup(payload: CategoryStoreGroupPayload) {
  return await http.post<APIResponse<CategoryStoreGroupResponse>>("group-category/create", payload);
}

async function updateCategoryGroup(idCategoryGroup = '', payload: CategoryStoreGroupPayload) {
  return await http.patch<APIResponse<CategoryStoreGroupResponse>>(`group-category/update?id=${idCategoryGroup}`, payload);
}

async function getCategoryGroup(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
    if (loginInfo?.value?.job?.id != undefined){
    queryParam = queryParam + '&job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<CategoryStoreGroupResponse>>(`group-category?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findCategoryGroup(idCategoryGroup = "") {
  return await http.get<APIResponse<CategoryStoreGroupResponse>>(`group-category/detail?id=${idCategoryGroup}`);
}

async function deleteCategoryGroup(idCategoryGroup = "") {
  return await http.delete<APIResponse<CategoryStoreGroupResponse>>(`group-category/delete?id=${idCategoryGroup}`);
}

export default {
  createCategoryGroup,
  updateCategoryGroup,
  getCategoryGroup,
  findCategoryGroup,
  deleteCategoryGroup
};